// for sharing Detail page of catlogue car

import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "./Utils/Loader";
import Info from "./Utils/Info";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import Footer from "./Utils/Footer";
import Header from "./Header";
import {
  GetDealerdata,
  handleGetApiGF,
  handlePostApiGF,
  shareIphonePostMsg,
  Shareurl,
  Toast,
  Userlogin,
  validatorGF,
} from "./Utils/general-function";
import { Modal } from "react-bootstrap";
import NoCars from "./Utils/NoCars";
function OtherCarDetails(props) {
  const [Catloguedetail, setCatloguedetail] = useState({ carnumber: "" });
  const [Photolist, setPhotolist] = useState([]);
  const [DealerData, setDealerData] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [showBranding, setshowBranding] = useState(false);
  const [registrationData, setRegistration] = useState({
    registerName: "",
    registerMobile: "",
  });
  const [sold, setSold] = useState("");
  let params = useParams();
  const iphone = window.navigator.userAgent.includes("Mac");

  const getRegistrationData = async () => {
    const registrationRes = await handleGetApiGF({
      url: "/api/DealerRegistration/GetDelearprofile",
    });

    if (!registrationRes?.succ) {
      Toast(false, "", registrationRes?.msg || "Something went wrong");
      return;
    }
    setRegistration((prev) => ({
      ...prev,
      registerName: registrationRes?.data?.Data[0]?.Name,
      registerMobile: registrationRes?.data?.Data[0]?.Mobileno,
    }));
  };

  useEffect(() => {
    if (Userlogin() && !localStorage.getItem("loginMobile")) {
      getRegistrationData();
    }
    fetch(
      process.env.REACT_APP_API_ENDPOINT +
        "/api/Carmaster/GetdetailsofCarsbyRandomid?Randomno=" +
        params.carno
    )
      .then((response) => response.json())
      .then(async (res) => {
        console.log("res", res);
        if (res.Success && res?.Data) {
          setCatloguedetail(res.Data);
          setPhotolist(res.Data.catlogephotolist || []);
          setDealerData(res.Data.dealerprofilelist[0] || []);
          setshowBranding(false);
        } else if (res.Success && res.Message === "Sold Out...") {
          setSold(true); //this page link is being share so
          setLoading(false);
        }
      });
  }, [navigate, params.carno]);

  const handleload = () => {
    setLoading(false);
  };

  const onSubmitInquiry = async () => {
    // when a dealer want to see others dealer detail
    // if (!Validate()) return;
    setLoading(true);

    var param = {
      Name: localStorage.getItem("Ca1nioamed") || DealerData?.Firmname,
      Contactno:
        localStorage.getItem("loginMobile") || registrationData?.registerMobile,
      Carno: Catloguedetail?.carnumber,
      // nDealerRandno: "",
      nDealerRandno: DealerData?.Rand,
      nRemarks: "Lead from Dealer",
      salesexecutiveId: "0",
      LeadType: "DealerLead",
      Modelid: Catloguedetail?.modelid, //dynamic pass
    };

    try {
      let res = await handlePostApiGF({
        url: "/api/LeadQRCode/AddLeadQRCode",
        obj: param,
      });

      if (res.succ || res.msg === "Lead Already Exists") {
        setshowBranding(true);
      } else {
        Toast(res.succ, res.msg, res.msg);
      }
    } finally {
      setLoading(false);
    }
  };

  // const Validate = () => {
  //   let errors = {};
  //   let isValid = true;
  //   const { nameDealer, mobileDealer } = input;

  //   ({ returnErr: errors.nameDealer, returnValid: isValid } = validatorGF({
  //     Case: "onlyChar",
  //     val: nameDealer,
  //     isvalid: isValid,
  //   }));

  //   ({ returnErr: errors.mobileDealer, returnValid: isValid } = validatorGF({
  //     Case: "mobile",
  //     val: mobileDealer,
  //     isvalid: isValid,
  //   }));

  //   setInput((pre) => ({ ...pre, err: errors }));

  //   return isValid;
  // };

  const Poster = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    autoplaySpeed: 5000,
    swipeToSlide: true,
    cssEase: "linear",
  };

  return (
    <div
      className="page-space mb56"
      style={{ marginTop: Userlogin() ? "" : "-66px" }}
    >
      {Userlogin() ? <Header /> : null}
      {loading ? <Loader /> : null}
      {sold ? (
        <NoCars msg="The car you're looking for has been sold" />
      ) : (
        <>
          {Userlogin() ? (
            <div className="fixshare">
              <button
                onClick={(e) =>
                  iphone
                    ? shareIphonePostMsg({
                        url: window.location.href,
                        action: "urlshare",
                      })
                    : Shareurl(window.location.href)
                }
                className="sharebtn"
              >
                Share
                <span>
                  <img src="assets/images/share.png" alt="" />
                </span>
              </button>
            </div>
          ) : null}

          <div>
            <div id="forshare">
              {/*not in used  <Titleinfo
            dataFromParent={{
              data: Catloguedetail,
              carno: "****" + Catloguedetail.carnumber.substring(6),
            }}
          /> */}
              {/* <div>
                <h2 className="car-name" style={{ color: "red" }}>
                  {Catloguedetail?.modelyear} {Catloguedetail?.companyid}{" "}
                  {Catloguedetail?.carmodelid} {Catloguedetail?.variantid}
                </h2>
                <div className="car-number">
                  <span>{Catloguedetail?.km} km</span>
                  <span> • {Catloguedetail?.nCc} cc </span>
                </div>
              </div> */}
            </div>

            <div className="carslider npd2">
              <Slider {...Poster}>
                {Photolist.map((list) => (
                  <div className="car-reldiv" key={list.id}>
                    <TransformWrapper>
                      <TransformComponent>
                        <img
                          src={list.carphoto}
                          className="car-image"
                          alt=""
                          onLoad={handleload}
                        />
                      </TransformComponent>
                    </TransformWrapper>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
          <div style={{ margin: "15px" }}>
            <div>
              <h2 className="car-name" style={{ color: "red" }}>
                {Catloguedetail?.modelyear} {Catloguedetail?.companyid}{" "}
                {Catloguedetail?.carmodelid} {Catloguedetail?.variantid}
              </h2>
              <div className="car-number">
                {Catloguedetail?.km && <span>{Catloguedetail?.km} km •</span>}
                <span> {Catloguedetail?.nCc} cc </span>
              </div>
            </div>
          </div>
          <Info dataFromParent={Catloguedetail} />
          {/* user should be login otherwise hide get seller detail button */}
          {Userlogin() &&
            (!showBranding ? (
              <div className="text-center mb-3 mt-2">
                <div className="animbtndiv">
                  <button
                    className="web-btn w-100 mt-2"
                    onClick={onSubmitInquiry}
                  >
                    Get Seller Details
                  </button>
                  <div className="circle c-1"></div>
                  <div className="circle c-2"></div>
                </div>
              </div>
            ) : (
              <div className="mb-2">
                <Footer dataFromParent={DealerData} />
              </div>
            ))}
        </>
      )}

      {/* <ScrollButton/> */}
    </div>
  );
}

export default OtherCarDetails;
